var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3553 9.75002V7.97729H13.2895C13.6172 7.97729 14.0132 8.29833 14.0132 8.86366C14.0132 9.42899 13.6172 9.75002 13.2895 9.75002H10.3553Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3553 13.0227V11.25H14.0263C14.3541 11.25 14.75 11.571 14.75 12.1364C14.75 12.7017 14.3541 13.0227 14.0263 13.0227H10.3553Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V15C21 16.1046 20.1046 17 19 17H5C3.89543 17 3 16.1046 3 15V6ZM10.3421 5.25C9.92789 5.25 9.59211 5.58579 9.59211 6V6.47727H8.5C8.08579 6.47727 7.75 6.81306 7.75 7.22727C7.75 7.64149 8.08579 7.97727 8.5 7.97727H8.85526V13.0227H8.5C8.08579 13.0227 7.75 13.3585 7.75 13.7727C7.75 14.1869 8.08579 14.5227 8.5 14.5227H9.59211V15C9.59211 15.4142 9.92789 15.75 10.3421 15.75C10.7563 15.75 11.0921 15.4142 11.0921 15V14.5227H11.4342V15C11.4342 15.4142 11.77 15.75 12.1842 15.75C12.5984 15.75 12.9342 15.4142 12.9342 15V14.5227H14.0263C15.3264 14.5227 16.25 13.3785 16.25 12.1364C16.25 11.3124 15.8436 10.5315 15.1904 10.0991C15.3975 9.73046 15.5132 9.30318 15.5132 8.86364C15.5132 7.62149 14.5895 6.47727 13.2895 6.47727H12.9342V6C12.9342 5.58579 12.5984 5.25 12.1842 5.25C11.77 5.25 11.4342 5.58579 11.4342 6V6.47727H11.0921V6C11.0921 5.58579 10.7563 5.25 10.3421 5.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.25C1.58579 18.25 1.25 18.5858 1.25 19C1.25 19.4142 1.58579 19.75 2 19.75H22C22.4142 19.75 22.75 19.4142 22.75 19C22.75 18.5858 22.4142 18.25 22 18.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinLaptop);
export default __webpack_public_path__ + "static/media/bitcoin-laptop.99a3e43cbda30590cb69b8afa2f80cfa.svg";
export { ForwardRef as ReactComponent };